import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service";
import { SettingsType } from "../types/settings";

const client = new HTTPClient();

export interface ResponseType {
    settings?: {
        data : Array<SettingsType>;
    };
    error?: string;
}

export interface SettingsFormResponse {
    success: boolean;
    error?: string;
}


class SettingsModel {
    static async save(item: SettingsType){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.PUT,
            `${AUTH_URL}/settings`,
            JSON.stringify(item),
            auth.accessToken,
        );

        const response = await client.put(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as SettingsFormResponse
    }

    static async find(){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/settings`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ResponseType
    }
}

export default SettingsModel